module.exports = __webpack_public_path__ + "img/logo_indicator.f840db75.svg";